module.exports = __webpack_public_path__ + "static/media/14GalleryPuppets.46b457c5.jpeg";